import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Cookie,
  useRouter,
  connect,
} from "../../atoms/DependencyHelper";
import NextStepsInfo from "../../molecules/nextStepsInfo/NextStepsInfo";
import PurchasedItems from "../../molecules/purchasedOrder/purchasedItems/PurchasedItems";
import PurchasedSectionInfo from "../../molecules/purchasedOrder/purchasedSectionInfo/PurchasedSectionInfo";
import DebicheckLink from "../../organisms/debicheckMandate/DebicheckLink";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import Image from "../../atoms/image/image";
import { getSalesOrder } from "../../../services/checkoutService";
import * as pageAPI from "../../../services/pageService";
import {
  showSpinner,
  hideSpinner,
  imagePrefix,
  urlPrefix,
  createMarkup,
  getCookieValue,
  splitCartItems,
} from "../../../utils/helperServices";
import labels from "../../../config/labels";
import {
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  setPaymentMethodUrl,
  setPostOrderResponse,
} from "../../../Redux/actions/checkoutAction";
import config from "../../../config/index";
import { CREDIT_VETTING_STATUS } from "../../../config/constants";
import { journeyType } from "../../../context/checkout-journey-context";
import styles from "./CheckoutOrderConfirmation.module.scss";
import * as Analytics from "../../../services/analyticsUtag";
import types from "../../../config/types";

const CheckoutOrderConfirmation = ({
  cartProducts,
  userLoggedIn,
  profileData,
  customerStatus,
  setShowSnackBar,
  navigate,
  setPageErr,
  applicationType,
  debitDetails,
  deliveryDetails,
  authDetailsData,
  upgradeResponse,
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  setPaymentMethodUrl,
  setPostOrderResponse,
}) => {
  const orderId = getCookieValue(config.order_id);
  const [viewSent, setViewSent] = useState(false);

  const [dataFail, setDataFail] = useState(true);
  const [orderData, setOrderData] = useState(null);
  const [content, setContent] = useState(null);

  const continueBtnConfig = {
    buttonStyle: "outline black",
    buttonLabel: "Continue shopping",
  };
  const emailDocBtnConfig = {
    buttonStyle: "solid black",
    buttonLabel: "Email documents now",
  };

  const upgradeAnalyticsData = {
    upgrade_eligibility_status: upgradeResponse?.eligibilityStatus,
    upgrade_eligible_date: upgradeResponse?.upgradeDate || "",
    upgrade_customer_type: upgradeResponse?.c3dCustomer
      ? "C3D"
      : upgradeResponse?.business
      ? "CBU"
      : "OTHER",
  };
  const router = useRouter();

  const getCategoriesArr = () => {
    if (cartProducts.length > 0) {
      if (applicationType == "normal") {
        return cartProducts.map((item) => item?.product?.categories?.[0]?.name);
      } else {
        return cartProducts.map((item) => item?.product?.categories?.[1]?.name);
      }
    }
    return [];
  };

  const getQuantityArr = () => {
    if (cartProducts.length > 0) {
      return cartProducts.map((item) => item?.quantity);
    }
    return [];
  };

  function getDealFormattedPrice(item) {
    return `${item?.product?.monthly_recurring} x ${item?.product?.payment_terms_label}`;
  }

  const getPriceArr = () => {
    if (cartProducts.length > 0) {
      if (applicationType == "normal") {
        return cartProducts.map(
          (item) => item?.prices?.row_total_original?.value
        );
      } else {
        return cartProducts.map((item) => getDealFormattedPrice(item));
      }
    }
    return [];
  };

  const getProductSkuArr = () => {
    if (cartProducts.length > 0) {
      return cartProducts.map((item) => item?.product?.sku);
    }
    return [];
  };

  const getProductNameArr = () => {
    if (cartProducts.length > 0) {
      return cartProducts.map((item) => item?.product?.name);
    }
    return [];
  };

  const dealCartProducts = (orderData?.order?.items || []).filter(
    (item) =>
      parseInt(item?.is_deal_product) === 1 || item?.parent_product_sku != null
  );
  const onceOffCartProducts = (orderData?.order?.items || []).filter(
    (item) =>
      parseInt(item?.is_deal_product) === 0 && item?.parent_product_sku == null
  );

  const isPreOrder = () => {
    let preOrderFound = cartProducts.filter(
      (item) =>
        item?.product?.badges_label &&
        item?.product?.badges_label
          .toLowerCase()
          .indexOf(types.TYPE_PREORDER.toLowerCase()) > -1
    );
    if (preOrderFound && preOrderFound.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const salesAnalyticsData = {
    sales_product_category: getCategoriesArr(),
    sales_product_id: getProductNameArr(),
    sales_product_name: getProductSkuArr(),
    sales_product_price: getPriceArr(),
    sales_product_quantity: getQuantityArr(),
    preorder_sales_event: isPreOrder() ? "cbu_pre_order" : "",
  };
  salesAnalyticsData.multicart_flag =
    dealCartProducts?.length > 0 && onceOffCartProducts?.length > 0
      ? true
      : false;

  const successAnalytics = (journey, cerditStatus) => {
    if (applicationType == "normal") {
      Analytics.view({
        page_event: "view",
        page_name: `checkout: order confirmation: ${customerStatus}`,
        ...salesAnalyticsData,
        ...Analytics.getProfileData(userLoggedIn, profileData, authDetailsData),
      });
    } else {
      if (journey == journeyType.upgrade) {
        Analytics.view({
          page_event: "view",
          page_name: `checkout: order confirmation: ${customerStatus}`,
          delivery_type:
            deliveryDetails?.receiveType == "store" ? "collect" : "deliver",
          authentication_id_type:
            authDetailsData?.idType == "PASSPORT" ? "passport" : "id",
          ...upgradeAnalyticsData,
          ...salesAnalyticsData,
          ...Analytics.getUtagData([
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
          ]),
          visitor_subscription_type: "postpaid",
        });
      } else {
        Analytics.view({
          page_event: "view",
          page_name: `checkout: order confirmation: ${customerStatus}: ${cerditStatus}`,
          delivery_type:
            deliveryDetails?.receiveType == "store" ? "collect" : "deliver",
          authentication_id_type:
            authDetailsData?.idType == "PASSPORT" ? "passport" : "id",
          ...salesAnalyticsData,
          ...Analytics.getUtagData([
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
          ]),
          visitor_subscription_type: "postpaid",
        });
      }
    }
    setViewSent(true);
  };

  async function getOrder() {
    try {
      showSpinner();
      let results = await getSalesOrder(orderId);
      if (!results.fail) {
        if (results.order && Object.keys(results.order).length > 0) {
          if (results.order?.order_status == "CQFD_SUBMIT_FAIL") {
            setDataFail(true);
            redirectToTechnicalError("cqfd");
          } else {
            let vettingResult =
              results?.order?.journey_type == journeyType.upgrade
                ? CREDIT_VETTING_STATUS.approved
                : results?.order?.vetting_result;
            setOrderData(results);

            if (vettingResult && results?.order?.journey_type) {
              fetchPageContent(
                results?.order?.journey_type,
                results?.order?.vetting_result
              );
            } else {
              if (!viewSent) {
                successAnalytics(null, null);
              }
              setDataFail(false);
              hideSpinner();
            }
          }
        } else {
          setDataFail(true);
          redirectToTechnicalError();
        }
      } else {
        if (results && results.errors) {
          Analytics.link({
            ...Analytics.getUtagData(["page_name"]),
            page_form_event: "error",
            page_errors: `${
              results.errors[0] ? results.errors?.[0].message : ""
            }`,
            page_errors_code: `chk-dxl-g-so-${results.status}`,
          });
        }
        setDataFail(true);
        redirectToTechnicalError();
      }
    } catch {
      setDataFail(true);
      redirectToTechnicalError();
    }
  }

  useEffect(() => {
    showSpinner();
    if (customerStatus) {
      getOrder();
    }
  }, [customerStatus]);

  const mapResultCode = (journey, cerditStatus) => {
    let endPoint;
    if (journey == journeyType.upgrade) {
      endPoint = labels.orderConfirmation.errorCodes.upgradeApproved;
    } else if (journey == journeyType.newLine) {
      switch (cerditStatus) {
        case CREDIT_VETTING_STATUS.approved:
          endPoint = labels.orderConfirmation.errorCodes.newLineApproved;
          break;
        case CREDIT_VETTING_STATUS.pending:
        case CREDIT_VETTING_STATUS.referred:
          endPoint =
            authDetailsData?.idType == "PASSPORT"
              ? labels.orderConfirmation.errorCodes.newLinePendedPassport
              : labels.orderConfirmation.errorCodes.newLinePendedId;
          break;
        case CREDIT_VETTING_STATUS.offline:
          endPoint = labels.orderConfirmation.errorCodes.newLineOffline;
          break;
        case CREDIT_VETTING_STATUS.approvedWithConditions:
          endPoint =
            labels.orderConfirmation.errorCodes.newLineApprovedWithConditions;
          break;
      }
    } else {
      switch (cerditStatus) {
        case CREDIT_VETTING_STATUS.approved:
          endPoint = labels.orderConfirmation.errorCodes.addLineApproved;
          break;
        case CREDIT_VETTING_STATUS.pending:
        case CREDIT_VETTING_STATUS.referred:
          endPoint =
            authDetailsData?.idType === "PASSPORT"
              ? labels.orderConfirmation.errorCodes.addLinePendedPassport
              : labels.orderConfirmation.errorCodes.addLinePendedId;
          break;
        case CREDIT_VETTING_STATUS.offline:
          endPoint = labels.orderConfirmation.errorCodes.addLineOffline;
          break;
        case CREDIT_VETTING_STATUS.approvedWithConditions:
          endPoint =
            labels.orderConfirmation.errorCodes.addLineApprovedWithConditions;
          break;
      }
    }

    return endPoint;
  };

  /**
   * Get the content display data
   */
  const fetchPageContent = async (journey, cerditStatus) => {
    let endPoint = mapResultCode(journey, cerditStatus);
    try {
      const results = await pageAPI.getPageComponents([`${endPoint}/CBU`]);

      if (results && results.status === "error") {
        Analytics.link({
          page_name: `checkout: order confirmation: ${customerStatus}`,
          page_form_event: "error",
          page_errors: `${results.reason ? results.reason : ""}`,
          page_errors_code: `chck-d-g-seo`,
        });
        setDataFail(true);
        redirectToTechnicalError();
      } else {
        if (applicationType !== "normal") {
          setShowSnackBar({
            visible: true,
            message:
              labels.orderConfirmation.lbl_order_fullfilment_stock_dependant,
            type: "alert",
            className: styles["top-notification"],
            dismissClass: styles["dismiss"],
          });
        }

        if (!viewSent) {
          successAnalytics(journey, cerditStatus);
        }
      }

      setContent(results);
      setDataFail(false);
      hideSpinner();
    } catch {
      setDataFail(true);
      redirectToTechnicalError();
    }
  };

  const redirectToTechnicalError = (type = "error") => {
    const pageName = `checkout: order confirmation: ${customerStatus}`;

    setPageErr({
      type: "error",
      title:
        type == "cqfd"
          ? labels.orderConfirmation.lbl_cqfd_order_fail_heading
          : labels.orderConfirmation.lbl_order_fail_heading,
      desc:
        type == "cqfd"
          ? labels.orderConfirmation.lbl_cqfd_order_fail_description
          : labels.orderConfirmation.lbl_order_fail_description,
      primaryLabel: "View order history",
      secondaryLabel: "Exit checkout",
      handlePrimaryClick: () =>
        handlePrimaryClick("/view-order-history", "view order history"),
      handleSecondaryClick: () => handleSecondaryClick(null, "exit checkout"),
      imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
      pageName: pageName,
    });
    hideSpinner();
    navigate("pageError");
  };

  const handlePrimaryClick = async (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url) {
      await router.push(`${urlPrefix}${url}`).then(() => {
        hideSpinner();
      });
    } else {
      await router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
        hideSpinner();
      });
    }
    await clearReduxState();
  };

  const handleSecondaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    clearReduxState();
    if (url) {
      router.push(`${urlPrefix}${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`${urlPrefix}/cart`).then(() => {
        hideSpinner();
      });
    }
  };

  const SubDescription = ({
    cerditStatus,
    journey,
    content,
    referenceNumber,
    deliveryDays,
  }) => {
    if (applicationType == "normal") {
      return (
        <>
          <hr />
          <div className={styles["sub-content"]}>
            {labels.orderConfirmation.lbl_normal_sub_desc}
          </div>
        </>
      );
    } else {
      if (
        journey == journeyType.upgrade ||
        cerditStatus == CREDIT_VETTING_STATUS.approved ||
        cerditStatus == CREDIT_VETTING_STATUS.approvedWithConditions
      ) {
        return (
          <>
            <hr />
            <div className={styles["sub-content"]}>
              <div
                className={styles["title"]}
                dangerouslySetInnerHTML={createMarkup(content)}
              ></div>
              <div className={styles["days"]}>{deliveryDays}</div>
            </div>
          </>
        );
      } else if (
        cerditStatus == CREDIT_VETTING_STATUS.pending ||
        cerditStatus == CREDIT_VETTING_STATUS.referred ||
        cerditStatus == CREDIT_VETTING_STATUS.offline
      ) {
        return (
          <>
            <hr />
            <div className={styles["sub-content"]}>
              <div
                className={styles["title"]}
                dangerouslySetInnerHTML={createMarkup(content)}
              ></div>
            </div>
            <div className={styles["reference"]}>
              <div className={styles["title"]}>
                {labels.orderConfirmation.lbl_your_reference_number}
              </div>
              <div className={styles["value"]}>{referenceNumber}</div>
            </div>
          </>
        );
      } else {
        return null;
      }
    }
  };

  const PageHeading = ({ journey, cerditStatus, customerName }) => {
    if (
      journey !== journeyType.upgrade &&
      (cerditStatus == CREDIT_VETTING_STATUS.pending ||
        cerditStatus == CREDIT_VETTING_STATUS.referred)
    ) {
      return (
        <div className={styles["heading"]} id="heading">
          {labels.orderConfirmation.lbl_we_need_documents}
        </div>
      );
    } else {
      return (
        <div className={styles["heading"]} id="heading">
          Thank you, {customerName}!
        </div>
      );
    }
  };

  const handleContinueShopping = async () => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: continue shopping`,
      link_url: `${urlPrefix}/products`,
    });

    await router.push(`${urlPrefix}/products`);
    await clearReduxState();
  };

  const clearReduxState = async () => {
    setNormalCheckoutCurrentStep(null);
    setPostCheckoutCurrentStep(null);
    removeCreditCheckStates(null);
    setPaymentMethodUrl(null);
    setPostOrderResponse({});

    Cookie.remove(config.order_id);
    Cookie.remove(config.pay_fail_count);
    Cookie.remove("guest_checkout");
  };

  const handleEmailDocument = async (cerditStatus) => {
    Analytics.link({
      link_type: "o",
      link_name: `checkout: order confirmation: ${customerStatus}: ${cerditStatus?.toLowerCase()}: email`,
      page_name: `checkout: order confirmation: ${customerStatus}`,
    });
  };

  const debiCheckMessage = (journey, cerditStatus) => {
    if (applicationType === "normal") {
      return <></>;
    }

    if (
      cerditStatus == CREDIT_VETTING_STATUS.pending ||
      cerditStatus == CREDIT_VETTING_STATUS.referred
    ) {
      return (
        <DebicheckLink
          msgType={
            debitDetails?.debiCheckFlag === "Y" ? "consent" : "noConsent"
          }
        ></DebicheckLink>
      );
    }

    if (journey === journeyType.upgrade || journey === journeyType.addLine) {
      return <DebicheckLink msgType="educational"></DebicheckLink>;
    } else {
      return (
        <DebicheckLink
          msgType={
            debitDetails?.debiCheckFlag === "Y" ? "consent" : "noConsent"
          }
        />
      );
    }
  };

  return (
    <>
      {!dataFail && orderData && (
        <>
          <CustomContainer className={styles["success-container"]}>
            <CustomContainer className={styles["top"]}>
              <Image
                id="checkout-success-tick"
                img_path={`${imagePrefix}/assets/images/success-circle.svg`}
                className={styles["icon"]}
              />
              <PageHeading
                customerName={orderData?.order?.customer_name}
                cerditStatus={orderData?.order?.vetting_result}
                journey={orderData?.order?.journey_type}
              />

              {applicationType !== "normal" &&
                orderData?.order?.vetting_result !==
                  CREDIT_VETTING_STATUS.offline &&
                orderData?.order?.vetting_result !==
                  CREDIT_VETTING_STATUS.pending &&
                orderData?.order?.vetting_result !==
                  CREDIT_VETTING_STATUS.referred && (
                  <div className={styles["main-content"]}>
                    {orderData?.order?.journey_type == journeyType.upgrade
                      ? labels.orderConfirmation.lbl_contract_upgrade_desc
                      : labels.orderConfirmation.lbl_contract_default_desc}
                  </div>
                )}
              <SubDescription
                cerditStatus={orderData?.order?.vetting_result}
                journey={orderData?.order?.journey_type}
                content={content?.sections[0]?.description}
                referenceNumber={orderData?.order?.tracking_number}
                deliveryDays={orderData?.order?.delivery_time_message}
              />
              {(orderData?.order?.vetting_result ==
                CREDIT_VETTING_STATUS.pending ||
                orderData?.order?.vetting_result ==
                  CREDIT_VETTING_STATUS.referred) &&
                orderData?.order?.journey_type !== journeyType.upgrade &&
                content?.sections[0]?.callToActionLabel && (
                  <div className={`${styles["button-section"]}`}>
                    <CTAButton
                      className={`${styles["btn"]} ${styles["email-doc-btn"]}`}
                      variant={emailDocBtnConfig.buttonStyle}
                      url={`mailto:${content?.sections[0]?.callToActionLabel}`}
                      handleClick={() =>
                        handleEmailDocument(orderData.order.vetting_result)
                      }
                    >
                      {emailDocBtnConfig.buttonLabel}
                    </CTAButton>
                  </div>
                )}
            </CustomContainer>

            {applicationType !== "normal" &&
              content?.sections[0]?.items?.length && (
                <CustomContainer
                  className={`${styles["mid"]} ${styles["next-steps"]}`}
                >
                  <NextStepsInfo
                    heading={content?.sections[0]?.headingTitle}
                    type={
                      orderData?.order?.journey_type == journeyType.upgrade ||
                      CREDIT_VETTING_STATUS.approved ==
                        orderData?.order?.vetting_result ||
                      CREDIT_VETTING_STATUS.approvedWithConditions ==
                        orderData?.order?.vetting_result
                        ? "step"
                        : "document"
                    }
                    content={content.sections[0].items}
                    subContent={
                      content?.sections[0]?.secondaryDescription
                        ? {
                            icon: content?.sections[0]?.icon,
                            description:
                              content?.sections[0]?.secondaryDescription,
                          }
                        : null
                    }
                    userEmail={orderData?.order?.customer_email}
                  />
                </CustomContainer>
              )}

            {debiCheckMessage(
              orderData?.order?.journey_type,
              orderData?.order?.vetting_result
            )}

            <CustomContainer className={styles["bottom"]}>
              {applicationType !== "normal" && (
                <CustomContainer className={styles["info-section"]}>
                  <PurchasedSectionInfo
                    heading="Order details"
                    type="order"
                    journey={orderData?.order?.journey_type}
                    orderData={orderData?.order}
                  />
                </CustomContainer>
              )}

              {deliveryDetails?.receiveType !== "store" ? (
                <CustomContainer className={styles["info-section"]}>
                  <PurchasedSectionInfo
                    heading="Delivery details"
                    type="delivery"
                    orderData={orderData?.order}
                  />
                </CustomContainer>
              ) : (
                <CustomContainer className={styles["info-section"]}>
                  <PurchasedSectionInfo
                    heading="Collection Details"
                    type="store"
                    orderData={orderData?.order}
                  />
                </CustomContainer>
              )}

              <CustomContainer
                className={`${styles["info-section"]} ${styles["purchased-items"]}`}
              >
                {dealCartProducts?.length ? (
                  <PurchasedItems
                    orderData={{ ...orderData?.order, items: dealCartProducts }}
                    applicationType="contract"
                    pageName="orderConfirmation"
                  />
                ) : (
                  ""
                )}
                {onceOffCartProducts?.length ? (
                  <PurchasedItems
                    orderData={{
                      ...orderData?.order,
                      items: onceOffCartProducts,
                    }}
                    applicationType="normal"
                    pageName="orderConfirmation"
                  />
                ) : (
                  ""
                )}
              </CustomContainer>
              {applicationType !== "normal" && (
                <CustomContainer className={styles["continue-btn"]}>
                  <CTAButton
                    className={styles["btn"]}
                    variant={continueBtnConfig.buttonStyle}
                    handleClick={handleContinueShopping}
                  >
                    {continueBtnConfig.buttonLabel}
                  </CTAButton>
                </CustomContainer>
              )}
            </CustomContainer>
          </CustomContainer>
        </>
      )}
    </>
  );
};

CheckoutOrderConfirmation.propTypes = {
  cartId: PropTypes.string,
  cartProducts: PropTypes.array,
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
};

CheckoutOrderConfirmation.defaultProps = {
  cartProducts: [],
};

const mapStateToProps = (state) => {
  return {
    debitDetails: state.creditCheckDetails.debitDetails,
    deliveryDetails: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    upgradeResponse: state.upgrade.upgradeResponse,
  };
};

const mapDispatchToProps = {
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  setPaymentMethodUrl,
  setPostOrderResponse,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutOrderConfirmation);
